import React from 'react';
import { assignmentTypeOf, dueDateOf, financialYearOf, formatDate, normalizedStatus, startDateOf } from '../../utils/assignmentUtils';

export default function AssignmentViewModal({ assignment, clientName, staffName, onClose }) {
  if (!assignment) return null;
  const rows = [
    ['Client', clientName],
    ['Assignment Type', assignmentTypeOf(assignment)],
    ['Financial Year', financialYearOf(assignment) || '—'],
    ['Period', assignment.period || '—'],
    ['Assigned To', staffName || '—'],
    ['Start Date', formatDate(startDateOf(assignment))],
    ['Due Date', formatDate(dueDateOf(assignment))],
    ['Status', normalizedStatus(assignment)],
    ['Linked Matter', assignment.matterCode || assignment.matterId || '—'],
    ['Remarks', assignment.remarks || '—'],
  ];
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-xl p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Assignment Details</h2>
          <button onClick={onClose} className="text-2xl leading-none text-gray-500">×</button>
        </div>
        <div className="divide-y">
          {rows.map(([label, value]) => (
            <div key={label} className="grid grid-cols-3 gap-3 py-3">
              <div className="font-medium text-gray-600">{label}</div>
              <div className="col-span-2 whitespace-pre-wrap">{value}</div>
            </div>
          ))}
        </div>
        <div className="flex justify-end mt-5"><button onClick={onClose} className="px-4 py-2 bg-gray-200 rounded">Close</button></div>
      </div>
    </div>
  );
}
